import {
  Card,
  CardContent,
  Grid,
  Typography,
  FormControlLabel,
  FormControl,
  Checkbox,
  Select,
  MenuItem,
} from "@mui/material";
import { CssTextField } from "./CommonStyles";
import DeliveryTextField from "./DeliveryTextField";

const DeliveryAddressComponent = ({
  checked,
  requestNewAddress,
  setRequestNewAddress,
  setRequestNewAddressChild,
  resetDeliveryAddress,
  setDelAddressDropValidation,
  setDeliveryAddressValidationFalse,
  delivery,
  defaultDelivery,
  handleDeliveryChange,
  delAddressDropValidation,
  delCustomerName,
  setCompanyNameValidation,
  setDelCustomerName,
  setDelCustomerNameChild,
  companyNameValidation,
  delContactName,
  setContactValidation,
  setDelContactName,
  setDelContactNameChild,
  contactValidation,
  delAddress1,
  setAddress1Validation,
  setDelAddress1,
  setDelAddress1Child,
  address1Validation,
  delAddress2,
  setDelAddress2,
  setDelAddress2Child,
  delAddress3,
  setDelAddress3,
  setDelAddress3Child,
  delAddress4,
  setDelAddress4,
  setDelAddress4Child,
  delPostalCode,
  setDelPostalCode,
  setDelPostalCodeChild,
  countries,
  delCountry,
  setCountryCodeValidation,
  setDelCountry,
  setDelCountryCodeChild,
  countryCodeValidation,
}) => (
  <Grid item xs={12} sm={6} md={8}>
    <label>
      <h5>
        <b>Delivery Address</b>
      </h5>
    </label>
    <Card variant="outlined">
      <CardContent sx={{ margin: 0 }}>
        <Grid item xs={3}>
          <FormControlLabel
            id="collect_order_chk"
            title="collector"
            disabled={checked}
            control={
              <Checkbox checked={requestNewAddress} style={{ paddingTop: 0 }} />
            }
            label={<h1>Request New Address</h1>}
            labelPlacement="start"
            onChange={(event) => {
              setRequestNewAddress(event.target.checked);
              setRequestNewAddressChild(event.target.checked);
              resetDeliveryAddress();
              if (event.target.checked) {
                setDelAddressDropValidation({ msg: "", invalid: false });
              } else {
                setDeliveryAddressValidationFalse();
              }
            }}
          />
        </Grid>
        <Grid container spacing={2}>
          {/* Delivery Address Dropdown */}
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              sx={{ minWidth: 50 }}
              style={{ width: "100%" }}
            >
              <Select
                id="delto"
                value={delivery?.length > 0 ? defaultDelivery : 0}
                onChange={handleDeliveryChange}
                disabled={checked || requestNewAddress}
                style={{ width: "100%", fontSize: "12px" }}
              >
                <MenuItem style={{ fontSize: "12px" }} value="0">
                  Select Address...
                </MenuItem>
                {delivery.map((optn, idx) => (
                  <MenuItem
                    key={(optn.shipToID ?? optn.contact_name) + "_" + idx}
                    value={optn.shipToID}
                    label={optn.contact_name}
                    style={{ fontSize: "12px" }}
                  >
                    {optn.contact_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {delAddressDropValidation.invalid && (
              <Typography style={{ color: "red" }} variant="subtitle2">
                {delAddressDropValidation.msg}
              </Typography>
            )}
          </Grid>
          {/* Customer Name */}
          <Grid item xs={12} sm={6} md={4}>
            <DeliveryTextField
              value={delCustomerName}
              onChange={setDelCustomerName}
              disabled={checked || !requestNewAddress}
              placeholder="Customer Name"
              validation={companyNameValidation}
              setValidation={setCompanyNameValidation}
              setValueChild={setDelCustomerNameChild}
              required
            />
          </Grid>

          {/* Contact Name */}
          <Grid item xs={12} sm={6} md={4}>
            <DeliveryTextField
              value={delContactName}
              onChange={setDelContactName}
              disabled={checked || !requestNewAddress}
              placeholder="Contact Name"
              validation={contactValidation}
              setValidation={setContactValidation}
              setValueChild={setDelContactNameChild}
              required
            />
          </Grid>
          {/* Address 1 */}
          <Grid item xs={12} sm={6} md={4}>
            <DeliveryTextField
              value={delAddress1}
              onChange={setDelAddress1}
              disabled={checked || !requestNewAddress}
              placeholder="Address 1"
              validation={address1Validation}
              setValidation={setAddress1Validation}
              setValueChild={setDelAddress1Child}
              required
            />
          </Grid>
          {/* Address 2 */}
          <Grid item xs={12} sm={6} md={4}>
            <DeliveryTextField
              value={delAddress2}
              onChange={setDelAddress2}
              disabled={checked || !requestNewAddress}
              placeholder="Address 2"
              setValueChild={setDelAddress2Child}
            />
          </Grid>
          {/* Address 3 */}
          <Grid item xs={12} sm={6} md={4}>
            <DeliveryTextField
              value={delAddress3}
              onChange={setDelAddress3}
              disabled={checked || !requestNewAddress}
              placeholder="Address 3"
              setValueChild={setDelAddress3Child}
            />
          </Grid>
          {/* Address 4 */}
          <Grid item xs={12} sm={6} md={4}>
            <DeliveryTextField
              value={delAddress4}
              onChange={setDelAddress4}
              disabled={checked || !requestNewAddress}
              placeholder="Address 4"
              setValueChild={setDelAddress4Child}
            />
          </Grid>
          {/* Post Code */}
          <Grid item xs={12} sm={6} md={4}>
            <DeliveryTextField
              value={delPostalCode}
              onChange={setDelPostalCode}
              disabled={checked || !requestNewAddress}
              placeholder="Post Code"
              setValueChild={setDelPostalCodeChild}
            />
          </Grid>

          {/* Country */}
          <Grid item xs={12} sm={6} md={4}>
            <FormControl
              variant="standard"
              sx={{ minWidth: 50 }}
              style={{ width: "100%" }}
            >
              <Select
                labelId="delto"
                id="delto"
                style={{
                  color: "black",
                  fontWeight: "normal",
                  fontSize: "12px",
                }}
                label="Select"
                disabled={checked || !requestNewAddress}
                onChange={(e) => {
                  setCountryCodeValidation({ msg: "", invalid: false });
                  setDelCountry(e.target.value);
                  setDelCountryCodeChild(e.target.value);
                }}
                value={countries?.length > 0 ? delCountry : "1"}
                placeholder="Country"
              >
                <MenuItem style={{ fontSize: "12px" }} value="1">
                  Select Country...
                </MenuItem>
                {countries.map((optn) => (
                  <MenuItem
                    key={optn.A2}
                    value={optn.A2}
                    label={optn.A2}
                    style={{
                      color: "black",
                      fontWeight: "normal",
                      fontSize: "12px",
                    }}
                  >
                    {optn.A2 + "-" + optn.Country}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {countryCodeValidation.invalid && (
              <Typography style={{ color: "red" }} variant="subtitle2">
                {countryCodeValidation.msg}
              </Typography>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  </Grid>
);

export default DeliveryAddressComponent;
